import {
  getTokenData
} from '@/utils/helpers'

export default {
  isLoggedIn: !!sessionStorage.getItem("token"),
  isInAdminRole: getTokenData().userRole === 'super_admin',
  isInManagerRole: getTokenData().userRole === 'manager',
  userId: getTokenData().userId,
  userRole: getTokenData().userRole,
  userName: getTokenData().userName,
  loading: false,
  redirect: '',
  enums: [],
  accesses: sessionStorage.getItem('accesses'),
}
